<script>
  import Heading from "../fragments/heading.svelte";
  import Media from "../media.svelte";

  let firstTableContent = "";
  let secondTableContent = "";

  fetch("static/table-content.json")
    .then(response => response.json())
    .then(response => {
      firstTableContent = response.first;
      secondTableContent = response.second;
    });
</script>

<style>
  .Table {
    margin-top: 2em;
    table-layout: fixed;
  }

  table td,
  table th {
    vertical-align: baseline;
    border-radius: 5px;
    border: solid 1px #c6c6c6;
    line-height: 1.2em;
    padding: 10px;
  }

  table th:empty {
    border: none;
  }

  table th {
    min-width: 130px;
  }
</style>

<div class="mb-xxl">
  <ul>
    <li>
      L’incubatore per l’innovazione in agricoltura e le sue start up agricole -
      <a href="#incubatoreInnovazioneAgricola">vai</a>
    </li>
    <li>
      Il supporto e l’ incubazione della valorizzazione delle eccellenze sulle
      lavorazione e servizi industriali -
      <a href="#dettagliIncubatoreInnovazioneAgricola">vai</a>
    </li>
  </ul>
</div>

<!-- <div class="page-container" id="incubatoreInnovazioneAgricola">
  <Heading dot="green" title="L’incubatore per l’ innovazione in agricoltura" />
  <ul>
    <li>
      <span class="red">
        Iniziativa nel contesto del processo di trasformazione della azienda
        agricola Ca’ TRON
      </span>
      ( 2000 ettari tra i comuni di Meolo , Roncade , Quarto d’ Altino e Venezia
      che già ospita BIG ROCK e H FARM) di
      <span class="red">
        Cattolica Assicurazioni nel centro di eccellenza europeo
        sull’innovazione in agricoltura
      </span>
    </li>

    <li>
      Nostro ruolo:
      <span class="red">
        sviluppare l’incubatore delle start up dell’agricoltura ed , economia
        circolare
      </span>
      con una particolare attenzione all’ambiente di terra e mare (si affaccia
      sulla laguna di Venezia fronte Torcello, Burano)
    </li>

    <li>
      Muove gli interessi dell’università di Venezia , della Regione Veneto ,
      del comune di Venezia
    </li>

    <li>Primo incubatore agricolo di Europa</li>
  </ul>
</div>

<div class="page-container" id="dettagliIncubatoreInnovazioneAgricola">
  <Heading dot="yellow" title="L’incubatore agricolo inizia da:" />

  <Media query={'(min-width: 764px)'} let:matches>
    {#if matches}
      <table class="Table">
        <thead>
          <th>Ragione sociale</th>
          <th>Focus</th>
          <th>Tecnologie</th>
          <th>Utilità cosa fa / sal</th>
        </thead>
        <tbody>
          {#each firstTableContent as content}
            <tr>
              <td>
                {@html content.ragioneSociale}
              </td>
              <td>
                {@html content.focus}
              </td>
              <td>
                {@html content.tecnologie}
              </td>
              <td>
                {@html content.utilita}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {:else}
      <div class="noTable">
        {#each firstTableContent as content}
          <div class="noTableContent mb-xl mt-xl">
            <div>
              <span class="bold">Ragione sociale:</span>
              <span>
                {@html content.ragioneSociale}
              </span>
            </div>
            <div>
              <span class="bold">Focus:</span>
              <span>
                {@html content.focus}
              </span>
            </div>
            <div>
              <span class="bold">Tecnologie:</span>
              <span>
                {@html content.tecnologie}
              </span>
            </div>
            <div>
              <span class="bold">Utilità cosa fa / sal:</span>
              <span>
                {@html content.utilita}
              </span>
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </Media>

</div> -->

<div class="page-container" style="overflow: scroll">
  <Heading
    dot="green"
    title="Il supporto e l'incubazione della valorizzazione delle lavorazione e
    servizi industriali in un'ottica globale" />

  <table class="Table">
    <thead>
      <th />
      <th />
      <th />
    </thead>
    <tbody>
      {#each secondTableContent as content}
        <tr>
          <td>
            {@html content.case}
          </td>
          <td class="bold red">
            {@html content.who}
          </td>
          <td>
            {@html content.what}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<div class="page-container">
  <Heading
    dot="green"
    title="Il supporto e l'incubazione della valorizzazione delle lavorazione e
    servizi industriali in un'ottica globale" />

  <ul>
    <li>Oggi a fronte</li>

    <ul>
      <li>
        di una profonda conoscenza e capacità di innovazione e RSS sui processi
        e le lavorazioni
      </li>

      <li>
        dimostrata da una competitività e abilità nel rispondere alle richieste
        personalizzate dei clienti di tutto il mondo
      </li>
    </ul>

    <li>
      esiste una incapacità di proteggere e a valorizzare a livello globale i
      saperi dei processi
    </li>

    <li>
      Se va bene vengono brevettate le novità dei macchinari. Mai si brevettano
      i nuovi processi di lavorazione che da questi macchinari o da altre
      soluzioni anche su tecnologie escogitate nascono
    </li>

    <li>
      Quindi si utilizzano queste abilità su mercati limitati e locali,
      concorrendo come forniture di lavoro e mai si fa leva su assets
      immateriali per competere a livello globale
    </li>

    <li>
      Organizziamo per le PMI i progetti di RSS sui nuovi processi ( non
      semplici investimenti ovviamente), abbiniamo privative ( brevetti ) di
      metodo , disciplinari privati ( tipo casa clima) e marchi , con un occhio
      di riguardo alla protezione nei paesi dove è maggiore la cultura ip si
      attua una globalizzazione dove si compete sulla conoscenza e non sul
      prezzo
    </li>
  </ul>
</div>
